import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import JobSearch from "@sourceflow-uk/job-search";
import { Container, Row, Col, Card } from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link";
import Arrow from "/public/site-assets/svg/black-arrow.svg";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from "swiper";
import JobCard from "@/components/JobCard";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export default function LatestJobs({
    global,
    pathPrefix,
    customClass = "",
    content,
    buttonTitle,
    buttonLink,
    post,
    swiperID,
    jobSearch = false,
    locale = "https://www.lorienglobal.com"
}) {
    const settings = {
        modules: [Navigation, Pagination, Autoplay],
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1,
        speed: 500,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            clickable: true,
            el: `.swiper-custom-paginations .${swiperID}`,
        },
        navigation: {
            nextEl: `.${swiperID}.swiper-next`,
            prevEl: `.${swiperID}.swiper-prev`
        },
        breakpoints: {
            1200: {
                slidesPerView: 4,
            },
            991: {
                slidesPerView: 3,
            },
            767: {
                slidesPerView: 2,
            },
        }
    }
    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass} position-relative`} id="latest-jobs">
                <Container>
                    <Row className="mb-4">
                        <Col md={6}>
                            {content ?
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                    {content}
                                </SourceFlowText>
                                : null}
                        </Col>
                        <Col md={6} className="d-flex justify-content-md-end align-items-center">
                            {jobSearch ?
                                null :
                                <div className="d-flex swiperArrowWrapper me-4">
                                    <button className={`${swiperID} arrow swiper-prev border-0 p-0`} aria-label="Prev"><Arrow /></button>
                                    <button className={`${swiperID} arrow swiper-next border-0 ms-2 p-0`} aria-label="Next"><Arrow /></button>
                                </div>}
                            {buttonLink ?
                                <div className="text-center">
                                    <Link href={`${buttonLink}`}>
                                        <a className="primaryBtn no-arrow m-0">
                                            {buttonTitle}
                                        </a>
                                    </Link>
                                </div> : null}
                            {jobSearch ?
                                <div className="w-100 mt-2 mt-md-0">
                                    <JobSearch
                                        options={{
                                            searchResults: false,
                                            searchFilters: false,
                                            submitDestination: `${locale}/jobs`,
                                        }}
                                        translations={{
                                            "input.placeHolder": "Job Title or Keyword",
                                            "button.text": "Search all jobs",
                                        }}
                                    />
                                </div> : null}
                        </Col>
                    </Row>
                    {jobSearch ?
                        <div className="d-flex swiperArrowWrapper justify-content-end mb-4">
                            <button className={`${swiperID} arrow swiper-prev border-0 p-0`} aria-label="Prev"><Arrow /></button>
                            <button className={`${swiperID} arrow swiper-next border-0 ms-2 p-0`} aria-label="Next"><Arrow /></button>
                        </div> : null}

                    <Swiper {...settings}>
                        {post?.map((job, index) =>
                            <SwiperSlide key={index}>
                                <JobCard
                                    {...job}
                                    post_lang={locale}
                                    slider={true}
                                />
                            </SwiperSlide>
                        )}
                    </Swiper>
                    <div className="text-center swiper-custom-paginations mt-4">
                        <div className={`${swiperID}`} />
                    </div>
                </Container>
            </section >
        )
    )
}